/* eslint-disable */
import React, { useState } from 'react';

import Button from '@mui/material/Button';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import { useSelector } from 'react-redux';
import './style.css';

function ActionEditButton(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('Primary Agent');

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  return (
    <div className="dropdown-container">
      <button
        className={`Active-btn-edit ${isOpen ? 'active' : ''}`}
        onClick={handleClick}
      >
        {selectedOption}
        <ArrowDropDownOutlinedIcon />
      </button>
      {isOpen && (
        <div className="dropdown-content">
          <ul>
            <li onClick={() => handleOptionSelect('Primary Agent')}>
              Primary Agent
            </li>
            <li onClick={() => handleOptionSelect('Secondary Agent')}>
              Secondary Agent
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default ActionEditButton;
